var _path, _path2, _path3, _path4, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.664 203.6C243.062 184.968 251.955 162.726 254.347 139.363C256.739 116.001 252.536 92.4382 242.208 71.3112C231.88 50.1842 215.835 32.326 195.867 19.734C175.9 7.14204 152.796 0.312922 129.142 0.0104963L127.5 126.566L228.664 203.6Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4493 226.803C61.5863 237.108 76.6393 244.744 92.7489 249.274C108.859 253.804 125.709 255.14 142.339 253.206C158.969 251.271 175.052 246.104 189.67 238C204.288 229.896 217.155 219.012 227.536 205.972L127.5 127.5L48.4493 226.803Z",
    fill: "#F7F8F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7933 71.8347C0.37635 97.4217 -3.12914 126.426 2.83433 154.234C8.79781 182.043 23.8878 207.059 45.7046 225.305L127.5 127.5L12.7933 71.8347Z",
    fill: "#F7F8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.876 0.010341C102.898 0.303018 80.4254 6.80065 60.8364 18.816C41.2474 30.8313 25.27 47.9175 14.594 68.2675L127.5 127.5L125.876 0.010341Z",
    fill: "#F7F8F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.108,
    cy: 127.892,
    rx: 71.4,
    ry: 70.6154,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPieChart);
export default __webpack_public_path__ + "static/media/LoadingPieChart.b96932b042060b23587bd6311e02c145.svg";
export { ForwardRef as ReactComponent };